import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { BlankLayout } from '@/layout';
import { createInvoice, init } from '@/model/invoice/actions';
import { makeSelectDetails, makeSelectInitialized } from '@/model/invoice/selectors';

const selectInitialized = makeSelectInitialized();
const selectDetails = makeSelectDetails();

const withInvoiceInitialization = (Component: React.FunctionComponent) => (
  props: { [k in string]: unknown },
): JSX.Element => {
  const dispatch = useDispatch();
  const [actionInProgress, setInProgress] = useState(false);
  const attemptedToCreate = useRef(false);
  const initialized = useSelector(selectInitialized);
  const details = useSelector(selectDetails);
  useEffect(() => {
    if (!initialized) {
      if (!actionInProgress) {
        setInProgress(true);
        (async (): Promise<void> => {
          setInProgress(false);
          await init()(dispatch);
        })();
      }
    } else if (!details?.value) {
      if (!attemptedToCreate.current) {
        if (!actionInProgress) {
          setInProgress(true);
          (async (): Promise<void> => {
            try {
              await createInvoice()(dispatch);
            } finally {
              attemptedToCreate.current = true;
              setInProgress(false);
            }
          })();
        }
      }
    }
  }, [initialized, details, dispatch, actionInProgress]);
  if (!initialized || (!details?.value && !attemptedToCreate.current)) {
    return <BlankLayout />;
  }

  return <Component {...props} />;
};

export default withInvoiceInitialization;
